import React, { useContext, useEffect, useRef, useState } from "react";
import { calculateIntersection, getObjectById, getTooltipTitle } from "../../../../../hooks/utils";
import { EditorInfoContext } from "../../../../../utis/userInfoContext";
import DraggableElement from "../../../../CommonComponents/Draggable/DraggableElement";
import ExtendBeyondModal from "../../../../Modals/EditorModals/ExtendBeyondModal";
import ViewLightBox from "../elementModal/elementSections/lightBoxSection/ViewLightBox";
import AnimatedElements from "./AnimtedElement";
import Element from "./Element";
import ElementIcons from "./ElementIcons";
import ResizableComponent from "./ResizableComponent";

const PdfElement = ({
  canvasRef,
  element,
  zoom,
  dimensions,
  setPageNumber,
  editortype,
  setResizeDimensions,
  resizeDimensions,
  timerOnDoc,
  elemClick,
  setVideoData,
  actionCableVideoMontior,
  setJumpPageNum,
  handleAction,
  disableClick = false, // <-- Add this line
  scrollActive
}) => {
  const resizableDimensions = {
    top: resizeDimensions[element.id]?.top == undefined ? dimensions?.top : resizeDimensions[element.id]?.top,
    left: resizeDimensions[element.id]?.left == undefined ? dimensions?.left : resizeDimensions[element.id]?.left,
    height: resizeDimensions[element.id]?.height == undefined ? dimensions?.height : resizeDimensions[element.id]?.height,
    width: resizeDimensions[element.id]?.width == undefined ? dimensions?.width : resizeDimensions[element.id]?.width,
  };
  //todo
  const { editElement, pageDimensions } = useContext(EditorInfoContext);

  const previousDimensions = useRef(dimensions);
  const [lgtObj, setLgtObj] = useState(null)
  const [showExtendModal, setShowExtendModal] = useState(false)
  const [visible, setVisible] = useState(false);
  const [bgColor, setBgColor] = useState('');
  const [isSaved, setIsSaved] = useState(false);

   useEffect(() => {
    if (element?.value?.bg_color) {
      setBgColor(element.value.bg_color);
    }
  }, [element?.value?.bg_color]);


  const bounds = {
    top: -resizableDimensions?.top,
    left: -resizableDimensions?.left,
    right:
      pageDimensions?.width -
      (resizableDimensions?.left + resizableDimensions?.width),
    bottom:
      pageDimensions?.height -
      (resizableDimensions?.top + resizableDimensions?.height),
  };

  const handleClick = (element) => {
    if (disableClick) return;

    // Reactivate scrolling if enabled on this element
    if (element?.value?.reactive === 'reactive' || element?.value?.reactivate_scroll) {
      if (typeof window !== 'undefined' && window?.objInit?.tlb) {
        window.objInit.tlb.disable_scroll = false;
      }

      // Remove any global blockers
      if (typeof document !== 'undefined') {
        document.body.classList.remove("scroll_disable");
        document.body.style.overflow = "auto";

        const wrapper = document.getElementById("parent_doc_wrapper");
        if (wrapper) {
          wrapper.style.overflowY = "scroll";
          wrapper.style.overflow = "auto";
        }

        const pdfElementList = document.getElementsByClassName("viewer-bg");
        Array.from(pdfElementList).forEach(el => {
          el.classList.remove("scroll_disable", "hidden-for-cyoa");
        });
      }
    }

    // Combined action: Link to + Jump to (uses lj_ prefixed keys)
    const hasLjLink = !!(element?.value?.lj_url || element?.value?.lj_mail || element?.value?.lj_phone);
    const hasLjPage = !!element?.value?.lj_page_link;
    if (hasLjLink || hasLjPage) {
      if (hasLjPage) {
        // Console log for Link & Jump to Page execution tracking
        console.log('🔗🚀 Link & Jump to Page - Element Clicked:', {
          elementId: element?.id,
          elementType: element?.element_type_name || 'Unknown',
          fromPage: pageNumber || 'Unknown',
          toPage: element.value.lj_page_link,
          linkUrl: element?.value?.lj_url || element?.value?.lj_mail || element?.value?.lj_phone || 'None',
          reactivateScrolling: element?.value?.reactivate_scroll || false,
          timestamp: new Date().toISOString()
        });

        const pageNumberInput = document.getElementById('pageNumber');
        if (pageNumberInput) {
          pageNumberInput.value = element.value.lj_page_link;
        }
        setPageNumber(Number(element.value.lj_page_link));
        setJumpPageNum(Number(element.value.lj_page_link));
      }
      if (element?.value?.lj_mail) {
        window.location.href = `mailto:${element.value.lj_mail}`;
      } else if (element?.value?.lj_phone) {
        const cleanPhone = element.value.lj_phone.replace(/\D/g, '');
        window.location.href = `tel:${cleanPhone}`;
      } else if (element?.value?.lj_url) {
        let validUrl = element.value.lj_url;
        if (!validUrl.startsWith("http://") && !validUrl.startsWith("https://")) {
          validUrl = `https://${validUrl}`;
        }
        window.open(validUrl, "_blank");
      }
      return;
    }

    // Standalone actions
    if (element?.value?.page_link) {
      // Console log for Jump to Page execution tracking
      console.log('🚀 Jump to Page - Element Clicked:', {
        elementId: element?.id,
        elementType: element?.element_type_name || 'Unknown',
        fromPage: pageNumber || 'Unknown',
        toPage: element?.value?.page_link,
        reactivateScrolling: element?.value?.reactivate_scroll || false,
        timestamp: new Date().toISOString()
      });

      const pageNumberInput = document.getElementById('pageNumber');
      if (pageNumberInput) {
        pageNumberInput.value = element?.value?.page_link;
      }
      setPageNumber(Number(element?.value?.page_link));
      setJumpPageNum(Number(element?.value?.page_link));
    } else if (element?.value?.url || element?.value?.mail || element?.value?.phone) {
      const inputValue = element?.value?.url;
      const inputMail = element?.value?.mail;
      const inputPhone = element?.value?.phone;
      if (inputMail) {
        window.location.href = `mailto:${inputMail}`;
      } else if (inputPhone) {
        const cleanPhone = inputPhone.replace(/\D/g, '');
        window.location.href = `tel:${cleanPhone}`;
      } else {
        let validUrl = inputValue;
        if (!inputValue.startsWith("http://") && !inputValue.startsWith("https://")) {
          validUrl = `https://${inputValue}`;
        }
        window.open(validUrl, "_blank");
      }
    } else if (element?.value?.light_box) {
      setLgtObj(getObjectById(element?.value?.light_box))
    }
  };

  const maskedDimensions = calculateIntersection(resizableDimensions, element?.id, pageDimensions);
  const tooltipTitle = getTooltipTitle(element);

  useEffect(() => {
    previousDimensions.current = dimensions;
  }, [...Object.values(dimensions)]);

  useEffect(() => {
    if (!Object.keys(editElement || {}).length) {
      setResizeDimensions(dimensions);
    }
  }, [editElement, zoom]);

// TIMER BASED ON USER SCROLL AND Page on viewport
  useEffect(() => {
  const input = document.getElementById("pageNumber");
  if (!input) return;

  let timeouts = [];

  const clearAllTimers = () => {
    timeouts.forEach(clearTimeout);
    timeouts = [];
  };

  const startTimers = () => {
    clearAllTimers();
    if (!timerOnDoc) {
      if (element?.sec_to_delay === 0) {
        setVisible(true);
        setBgColor(element?.value?.bg_color);
      } else {
        setVisible(false);
        setBgColor('');
        const showTimeout = setTimeout(() => {
          setVisible(true);
          setBgColor(element?.value?.bg_color);
        }, element?.sec_to_delay * 1000);
        timeouts.push(showTimeout);
      }

      if (element?.disappear_after > 0) {
        const hideTimeout = setTimeout(() => {
          setVisible(false);
          setBgColor('');
        }, (Number(element?.sec_to_delay) + Number(element?.disappear_after)) * 1000);
        timeouts.push(hideTimeout);
      }
    } else {
      setVisible(true);
      setBgColor(element?.value?.bg_color);
    }
  };

  let lastTriggeredPage = null;

  // Check immediately if we're already on the correct page
  const currentPage = parseInt(input.value, 10);
  if (currentPage === element?.page && lastTriggeredPage !== currentPage) {
    startTimers();
    lastTriggeredPage = currentPage;
  }

  const interval = setInterval(() => {
    const currentPage = parseInt(input.value, 10);
    if (currentPage === element?.page) {
      if (lastTriggeredPage !== currentPage) {
        startTimers();
        lastTriggeredPage = currentPage;
      }
    } else {
      // Optional: reset visibility if user scrolls away
      // lastTriggeredPage = null;
      // setVisible(false);
      // setBgColor('');
      // clearAllTimers();
    }
  }, 500);
  

  return () => {
    clearInterval(interval);
    clearAllTimers();
    setVisible(false);
  };
}, [element?.sec_to_delay, element?.disappear_after, element?.value?.bg_color, element?.page, timerOnDoc]);

  return (
    <>

      {
        showExtendModal &&
        element?.id == maskedDimensions?.id &&
        element?.geometry?.keep_within_page !== false &&
        resizableDimensions.width !== maskedDimensions?.intersectingWidth &&
        <ExtendBeyondModal
          openModal={showExtendModal}
          closeModal={setShowExtendModal}
          id={element?.id}
          resizableDimensions={resizableDimensions}
          previousDimensions={previousDimensions}
          setResizeDimensions={setResizeDimensions}
          setIsSaved={setIsSaved}
        />
      }
      <ViewLightBox setShowLightBox={setLgtObj} showLightBox={lgtObj} />
      <DraggableElement
        position={null}
        dimensions={dimensions}
        bounds={bounds}
        element={element}
        canvasRef={canvasRef}
        resizableDimensions={resizableDimensions}
        setResizeDimensions={setResizeDimensions}
        disabled={editortype !== "editor"}
      > 
        <div
          className="handle resizable" 
          onClick={() => handleClick(element)}
          style={{
            height: resizableDimensions?.height,
            width: resizableDimensions?.width,
            background: `${element?.geometry?.hide_beyond_page_edges == false && bgColor}`
          }}
          title={editortype == 'editor' ? tooltipTitle : 'Click to Continue'}
        >
          <>
            {editortype === "editor" ? (
              <ResizableComponent
                element={element}
                dimensions={dimensions}
                isSaved={isSaved}
                setIsSaved={setIsSaved}
                resizableDimensions={resizableDimensions}
                resizeDimensions={resizeDimensions}
                setResizeDimensions={setResizeDimensions}
                keepProportions={element?.geometry?.keep_proportions ?? true}
                setShowExtendModal={setShowExtendModal}
              >
                {editortype === "editor" && (
                  <ElementIcons
                    element={element}
                    resizableDimensions={resizableDimensions}
                    setResizeDimensions={setResizeDimensions}
                    previousDimensions={previousDimensions}
                    canvasRef={canvasRef}
                    zoom={zoom}
                  />
                )}
                {(element?.value?.animation || element?.sec_to_delay !== 0 || element?.disappear_after != 0) ? (
                  <AnimatedElements element={element} timerOnDoc={timerOnDoc} visible={visible}>
                    <Element
                      setVideoData={setVideoData}
                      actionCableVideoMontior={actionCableVideoMontior}
                      element={element}
                      dimensions={dimensions}
                      resizeDimensions={resizeDimensions}
                      zoom={zoom}
                      maskedDimensions={maskedDimensions}
                      elemClick={elemClick}
                      bgColor={bgColor}
                      handleClick={handleClick}
                      handleAction={handleAction}
                      editortype={editortype}
                    />
                  </AnimatedElements>
                ) : (
                  visible &&
                  <Element
                    setVideoData={setVideoData}
                    actionCableVideoMontior={actionCableVideoMontior}
                    element={element}
                    dimensions={dimensions}
                    resizeDimensions={resizeDimensions}
                    zoom={zoom}
                    maskedDimensions={maskedDimensions}
                    elemClick={elemClick}
                    bgColor={bgColor}
                    handleClick={handleClick}
                    handleAction={handleAction}
                    editortype={editortype}
                  />
                )}

              </ResizableComponent>
            ) : (
              <div
                style={{
                  width: `${dimensions?.width}px`,
                  height: `${dimensions?.height}px`,
                  position: "relative",
                }}
              >
                {(element?.value?.animation || element?.sec_to_delay !== 0 || element?.disappear_after != 0) ? (
                  <AnimatedElements element={element} timerOnDoc={timerOnDoc} visible={visible}>
                    <Element
                      element={element}
                      actionCableVideoMontior={actionCableVideoMontior}
                      setVideoData={setVideoData}
                      dimensions={dimensions}
                      resizeDimensions={resizeDimensions}
                      zoom={zoom}
                      maskedDimensions={maskedDimensions}
                      elemClick={elemClick}
                      bgColor={bgColor}
                      handleClick={handleClick}
                      handleAction={handleAction}
                      editortype={editortype}
                    />
                  </AnimatedElements>
                ) : (
                  visible &&
                  <Element
                    setVideoData={setVideoData}
                    element={element}
                    actionCableVideoMontior={actionCableVideoMontior}
                    dimensions={dimensions}
                    resizeDimensions={resizeDimensions}
                    zoom={zoom}
                    maskedDimensions={maskedDimensions}
                    bgColor={bgColor}
                    elemClick={elemClick}
                    handleClick={handleClick}
                    handleAction={handleAction}
                    editortype={editortype}
                  />
                )}
              </div>
            )}
          </>
            
        </div>
      </DraggableElement >
      
    </>
  );
};
export default React.memo(PdfElement);
